import {
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  onAuthStateChanged,
  signOut as fbSignOut,
  type User,
} from 'firebase/auth';
import { firebase } from './firebase';

const EMAIL_KEY = 'snippits.pendingEmail';

function actionCodeSettings(next: string | null) {
  const url = new URL('/signin', window.location.origin);
  if (next) url.searchParams.set('next', next);
  return {
    url: url.toString(),
    handleCodeInApp: true,
  };
}

export async function requestMagicLink(email: string, next: string | null) {
  await sendSignInLinkToEmail(firebase.auth, email, actionCodeSettings(next));
  window.localStorage.setItem(EMAIL_KEY, email);
}

export function isReturningFromEmailLink() {
  return isSignInWithEmailLink(firebase.auth, window.location.href);
}

export async function completeSignIn(emailOverride?: string) {
  const email = emailOverride ?? window.localStorage.getItem(EMAIL_KEY);
  if (!email) throw new Error('Missing email for sign-in link');
  await signInWithEmailLink(firebase.auth, email, window.location.href);
  window.localStorage.removeItem(EMAIL_KEY);
}

export function subscribeAuth(onChange: (user: User | null) => void) {
  return onAuthStateChanged(firebase.auth, onChange);
}

export function signOut() {
  return fbSignOut(firebase.auth);
}
